/* eslint-disable @reatom/unit-naming-rule */
import { action, reatomMap } from '@reatom/framework'

import type { Address } from '@root/entities/address/Address'
import type { Maker, Trade } from '@root/entities/trade'

export const reatomTradesTableMakers = () => {
  const makersCacheAtom = reatomMap<
    Address,
    { timestamp: Date; maker: Maker.TradeMaker }
  >()

  const resolveMakerAction = action((ctx, trade: Trade.Trade) => {
    const existingMaker = makersCacheAtom.get(ctx, trade.maker.address)
    if (!existingMaker) {
      makersCacheAtom.set(ctx, trade.maker.address, {
        timestamp: trade.timestamp,
        maker: trade.maker,
      })
      return trade.maker
    }

    if (trade.timestamp > existingMaker.timestamp) {
      makersCacheAtom.set(ctx, trade.maker.address, {
        timestamp: trade.timestamp,
        maker: trade.maker,
      })
      return trade.maker
    }

    return existingMaker.maker
  })

  const storeMakerAction = action((ctx, trade: Trade.Trade) => {
    resolveMakerAction(ctx, trade)
  })

  return {
    resolveMaker: resolveMakerAction,
    storeMaker: storeMakerAction,
    makersCache: makersCacheAtom,
  }
}
export type TradesTableMakersCache = ReturnType<
  typeof reatomTradesTableMakers
>['makersCache']
